import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';
import {
     API_GUEST_SUBSCRIBER_DELETE_CART,
     API_SUBSCRIBER_AWAITING_ORDERS_ITEMS,
     API_SUBSCRIBER_ORDERS_USER,
     LOCAL_CART,
     LOCAL_COUPON,
     LOCAL_COUPON_VOUCHERS,
} from '../../../../constants';

import { actionClearCart, actionRemoveCartVoucherRule } from '../Cart/actions';

// Order
export const SET_SUBSCRIBER_ORDERS_USER = 'setSubscriberOrdersUser';
export const SET_LIST_CE_PRODUCT_RPT = 'setListProductCeRPT';
export const SET_AWAITING_ORDER_ITEMS = 'setAwaitingOrderItems';

export const setSubscriberOrdersUser = (orders) => {
     return {
          type: SET_SUBSCRIBER_ORDERS_USER,
          payload: orders,
     };
};

export const setListCeProductRPT = (products) => {
     return {
          type: SET_LIST_CE_PRODUCT_RPT,
          payload: products,
     };
};

export const setAwaitingOrderItems = (orderItems) => {
     return {
          type: SET_AWAITING_ORDER_ITEMS,
          payload: orderItems,
     };
};

// Order
export const fetchSubscriberOrdersRequest = (setIsLoading) => (dispatch) => {
     // setIsLoading(true);

     callApi(API_SUBSCRIBER_ORDERS_USER, 'GET').then((response) => {
          // setIsLoading(false);

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          dispatch(setSubscriberOrdersUser(response.data));
     });
};

export const fetchAwaitingOrderItemsRequest = (setIsLoading) => (dispatch, useSelector) => {
     const user = useSelector().subscriber.user;
     if (!user) return;

     callApi(API_SUBSCRIBER_AWAITING_ORDERS_ITEMS.replace(':userId', user.id), 'GET').then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }
          dispatch(setAwaitingOrderItems(response.data));
     });
};

// Cart
export const removeDataRelatedToCart = () => (dispatch) => {
     localStorage.removeItem(LOCAL_CART);
     localStorage.removeItem(LOCAL_COUPON);
     localStorage.removeItem(LOCAL_COUPON_VOUCHERS);
     dispatch(actionClearCart());
     dispatch(actionRemoveCartVoucherRule());
};

export const removeSubscriberCartRequest = (id) => (dispatch) => {
     callApi(API_GUEST_SUBSCRIBER_DELETE_CART, 'DELETE', { id }).then((response) => {
          if (response.status !== 200) {
               return;
          }

          dispatch(removeDataRelatedToCart());
     });
};
